// const LANDING_BASE_URL = 'https://static.robinhood.in.th/app_link.html?URI=robinhoodth://landing%3F';
// const LANDING_BASE_URL = `https://static.robinhood.in.th/app_link.html?URI=robinhoodth://merchantlanding/id/${this.qrcode_text}`;

const STATIC_PAGE_URL_WITH_PARAM = 'https://static.robinhood.in.th/app_link.html?URI=';
const BLANK_REDIRECT_URI = 'robinhoodth://landing%3F';
const MERCHANT_REDIRECT_URI = 'robinhoodth://merchantlanding/id/';

export const blankMerchantUrl = `${STATIC_PAGE_URL_WITH_PARAM}${BLANK_REDIRECT_URI}`;
export const merchantUrl = (merchantId: string) => `${STATIC_PAGE_URL_WITH_PARAM}${MERCHANT_REDIRECT_URI}${merchantId}`;
export const qrCodeFoodSize = 68.55;
export const qrCodeFoodSizeM = 35;
